import React from "react";

import {
  Box,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  Skeleton,
  Typography,
} from "@mui/material";

import {
  formatDate_12h,
  detailsTabsBoxStyle,
  overviewListItemStyles,
} from "../../../services/Utils";

const hasDisplayValue = (value) =>
  value !== undefined &&
  value !== null &&
  value !== "";

/**
 * Reusable field matching the existing overview layout.
 */
const DetailField = ({
  label,
  value,
  loading = false,
  wordBreak = false,
}) => (
  <ListItem
    {...overviewListItemStyles}
    sx={[
      overviewListItemStyles?.sx,
      wordBreak && {
        "& .MuiListItemText-secondary": {
          wordBreak: "break-all",
          whiteSpace: "normal",
        },
      },
    ]}
  >
    <ListItemText
      primary={label}
      secondary={
        loading ? (
          <Skeleton
            variant="text"
            animation="wave"
            width="60%"
            height={26}
          />
        ) : hasDisplayValue(value) ? (
          value
        ) : (
          "-"
        )
      }
    />
  </ListItem>
);

const VehicleModelDetailsTab = ({
  modelData,
  isLoading = false,
}) => {
  return (
    <Box {...detailsTabsBoxStyle}>
      <Typography
        variant="subtitle1"
        component="h2"
        fontWeight={600}
        sx={{ mb: 2 }}
      >
        Model Details
      </Typography>

      <Divider sx={{ mb: 1 }} />

      <Grid
        container
        rowSpacing={2}
        columnSpacing={{
          xs: 1,
          sm: 2,
          md: 2,
        }}
      >
        {/* First column */}
        <Grid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
            lg: 4,
          }}
        >
          <List disablePadding>
            <DetailField
              label="Model Name"
              value={modelData?.name}
              loading={isLoading}
            />

            <DetailField
              label="Model Year"
              value={modelData?.modelYear}
              loading={isLoading}
            />

            <DetailField
              label="Region"
              value={modelData?.region}
              loading={isLoading}
            />
          </List>
        </Grid>

        {/* Second column */}
        <Grid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
            lg: 4,
          }}
        >
          <List disablePadding>
            <DetailField
              label="Created By"
              value={modelData?.createdBy}
              loading={isLoading}
              wordBreak
            />

            <DetailField
              label="Created Date"
              value={formatDate_12h(
                modelData?.createdAt
              )}
              loading={isLoading}
            />
          </List>
        </Grid>

        {/* Third column */}
        <Grid
          size={{
            xs: 12,
            sm: 6,
            md: 4,
            lg: 4,
          }}
        >
          <List disablePadding>
            <DetailField
              label="Updated By"
              value={modelData?.updatedBy}
              loading={isLoading}
              wordBreak
            />

            <DetailField
              label="Updated Date"
              value={formatDate_12h(
                modelData?.updatedAt
              )}
              loading={isLoading}
            />
          </List>
        </Grid>
      </Grid>
    </Box>
  );
};

export default VehicleModelDetailsTab;